import { Chip, Divider, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import React, { Fragment, useContext } from 'react';

import IndicatorWrapper from 'Common/IndicatorWrapper';

import { AssigmentPositionContext } from '../../assigment-position.context';
import Action from './Action';
import EditDialog from './EditDialog';

export default function AssigmentPositionList() {
  const { loading, ppeAssignmentsPosition } = useContext(AssigmentPositionContext);
  return (
    <IndicatorWrapper loading={loading} data={ppeAssignmentsPosition} errorMessage="Kayıt Bulunamadı.">
      <List id="classificationDefinitions">
        {ppeAssignmentsPosition?.map((item, index) => (
          <Fragment key={item?.id}>
            <ListItem>
              <ListItemAvatar>
                <AccountBalanceIcon className="text-gray" />
              </ListItemAvatar>
              <ListItemText color="primary">
                <ListItemText
                  primary={item?.label}
                  secondary={item?.ppeAssignments.map(positionData => (
                    <>
                      <Chip style={{ marginRight: '5px' }} icon={<AccountTreeIcon />} label={positionData?.position?.label} />
                    </>
                  ))}
                />
              </ListItemText>
              <ListItemSecondaryAction>
                <Action data={item} />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </Fragment>
        ))}
      </List>
      <EditDialog />
    </IndicatorWrapper>
  );
}
